export function getMatchAd (url: string, cb: (error: Error | null, response: any | null) => void) {
    const request = new XMLHttpRequest();

    request.open('GET', url);
    request.withCredentials = true;
    request.onload = function () {
        if (request.status === 200) {
            cb(null, JSON.parse(request.responseText));
        } else {
            cb(new Error('Unsuccessful request'), null);
        }
    };

    request.onerror = function () {
        cb(new Error('Network error'), null);
    };

    request.send();
}

export function doRequest (url: string) {
    const request = new XMLHttpRequest();
    request.open('GET', url);
    request.send();
}
